var map = {
	"./accessibility.svg": 2413,
	"./angular.svg": 3803,
	"./aws.svg": 2206,
	"./bootstrap.svg": 723,
	"./bootstrap4.svg": 1904,
	"./bootstrap5.svg": 5178,
	"./cpp.svg": 5312,
	"./css.svg": 7226,
	"./cybersecurity.svg": 8017,
	"./datascience.svg": 4290,
	"./excel.svg": 5382,
	"./fallback.svg": 2025,
	"./git.svg": 7425,
	"./go.svg": 770,
	"./html.svg": 8829,
	"./java.svg": 56,
	"./jquery.svg": 3069,
	"./js.svg": 6591,
	"./kotlin.svg": 8106,
	"./nodejs.svg": 4968,
	"./numpy.svg": 8274,
	"./pandas.svg": 5495,
	"./php.svg": 5595,
	"./python.svg": 4477,
	"./r.svg": 8415,
	"./react.svg": 4645,
	"./sass.svg": 7393,
	"./scipy.svg": 6762,
	"./sql.svg": 6321,
	"./statistics.svg": 332,
	"./tailwind.svg": 9204,
	"./w3css.svg": 8577
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6526;